import { UAParser } from "ua-parser-js";

export function getMobileOS(): "Android" | "iOS" | "Other" {
    // Possible 'os.name's: https://github.com/faisalman/ua-parser-js/tree/1.0.38#documentation
    const os = UAParser(navigator.userAgent).os.name;
    switch (os) {
        case "Android":
            return os;
        case "iOS":
            return os;
        default:
            return "Other";
    }
}

/**
 * Any Android WebView: our app's, or another app's in-app browser. Android puts a `wv` token in every
 * WebView's user agent; Chrome, Samsung Internet and Edge on Android do not carry it.
 *
 * A regex until we upgrade to ua-parser-js 2.x, which reports these as `browser.type === "inapp"`.
 * 1.x only names the browser, and names Facebook, Instagram and LinkedIn's WebViews after the app, so
 * a browser-name check misses them. 2.x is AGPL-3.0 (1.x is MIT), so the upgrade needs a licence decision.
 */
export function isAndroidWebView(): boolean {
    if (typeof navigator === "undefined") {
        return false;
    }

    return /; wv\)/.test(navigator.userAgent);
}
